import { gql } from '@apollo/client';

export const CREATE_ITEM = gql`
    mutation createItem($input: InsertItemInput!) {
        createItem(input: $input) {
            id
            localId
            taffiId
            price
            currency
            available
            title
            description
            categories {
                id
                name
            }
            tags {
                id
                name
            }
            sizes {
                id
                title
                value
            }
            colors {
                id
                title
                value
            }
            itemCodes
            url
            images
            accessLevel
            brand {
                id
                name
                value
                imageUrl
            }
            storeId
            storeProductId
            user {
                userType
            }
        }
    }
`;
export const UPDATE_ITEM = gql`
    mutation updateItem($input: InsertItemInput!) {
        updateItem(input: $input) {
            id
            localId
            taffiId
            price
            currency
            available
            title
            description
            categories {
                id
                name
            }
            tags {
                id
                name
            }
            sizes {
                id
                title
                value
            }
            colors {
                id
                title
                value
            }
            itemCodes
            url
            images
            accessLevel
            brand {
                id
                name
                value
                imageUrl
            }
        }
    }
`;
